import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { isSpectrum1D } from '../../../data/data1d/Spectrum1D';
import { useChartData } from '../../context/ChartContext';
import { useActiveSpectrum } from '../../hooks/useActiveSpectrum';
import Integral from './Integral';
function IntegralsSeries() {
    const { xDomains, data, displayerKey, view: { spectra: { activeTab: nucleus }, }, } = useChartData();
    const activeSpectrum = useActiveSpectrum();
    const Integrals = useMemo(() => {
        const isActive = (id) => {
            return activeSpectrum === null ? true : id === activeSpectrum.id;
        };
        return (_jsx("g", { className: "integrals", children: data?.[0] &&
                data
                    .filter((d) => d.display.isVisible && xDomains[d.id])
                    .filter((element) => isSpectrum1D(element))
                    .map((spectrum) => spectrum.integrals.values.map((integral) => (_jsx(Integral, { nucleus: nucleus, integral: integral, isActive: isActive(spectrum.id) }, integral.id)))) }));
    }, [activeSpectrum, data, nucleus, xDomains]);
    return _jsx("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, children: Integrals });
}
export default IntegralsSeries;
